
import React, { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle } from 'lucide-react';

const notifications = [
  { name: 'Minh Hoàng', city: 'Hà Nội', time: '2 phút trước' },
  { name: 'Thu Hương', city: 'TP.HCM', time: '5 phút trước' },
  { name: 'Đức Anh', city: 'Đà Nẵng', time: '8 phút trước' },
  { name: 'Mai Linh', city: 'Hải Phòng', time: '12 phút trước' },
  { name: 'Văn Tú', city: 'Cần Thơ', time: '15 phút trước' },
];

export const LiveNotifications = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const current = notifications[currentIndex];

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <div
        className={`transition-all duration-300 transform ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
        }`}
      >
        <Badge 
          variant="default" 
          className="bg-gradient-to-r from-emerald-600 to-blue-600 text-white px-4 py-3 shadow-2xl border border-white/20 animate-pulse"
        >
          <CheckCircle className="w-4 h-4 mr-2" />
          <span className="font-bold">{current.name}</span> từ {current.city} vừa tham gia - {current.time}
        </Badge>
      </div>
    </div>
  );
};
